import { useTranslation } from "react-i18next";
import { SubjectHistory } from "../../../../redux/apiSpecifications/apiSubjects";
import SubjectModifiedDescription from "./SubjectModifiedDescription";
import SubjectCreatedDescription from "./SubjectCreatedDescription";
import SubjectModifiedContactsDescription from "./SubjectModifiedContactsDescription";
import SubjectCreatedAddressDescription from "./SubjectCreatedAddressDescription";
import SubjectUpdatedAddressDescritpion from "./SubjectUpdatedAddressDescritpion";
import SubjectDeletedAddressDescription from "./SubjectDeletedAddressDescription";
import SubjectCreatedPaymentMethodDescription from "./SubjectCreatedPaymentMethodDescription";
import SubjectUpdatedPaymentMethodDescription from "./SubjectUpdatedPaymentMethodDescription";
import SubjectDeletedPaymentMethodDescription from "./SubjectDeletedPaymentMethodDescription";

interface IModifyDescriptionProps {
  item: SubjectHistory;
}

const ModifyDescription = ({ item }: IModifyDescriptionProps) => {
  const { t } = useTranslation();

  switch (item.modifyType) {
    //creazione soggetto
    case "SUBCRT":
      return (
        <SubjectCreatedDescription
          modifyDetailsJson={item.modifyDetailsJson!}
        />
      );
    //modifica dati anagrafici soggetto
    case "SUBNGRU":
      return (
        <SubjectModifiedDescription
          modifyDetailsJson={item.modifyDetailsJson!}
        />
      );
    //modifica dati contatto
    case "SUBCNCTU":
      return (
        <SubjectModifiedContactsDescription
          modifyDetailsJson={item.modifyDetailsJson!}
        />
      );
    //modifica indirizzi
    case "SUBDDRC":
      return (
        <SubjectCreatedAddressDescription
          modifyDetailsJson={item.modifyDetailsJson!}
        />
      );
    case "SUBDDRU":
      return (
        <SubjectUpdatedAddressDescritpion
          modifyDetailsJson={item.modifyDetailsJson!}
        />
      );
    case "SUBDDRD":
      return (
        <SubjectDeletedAddressDescription
          modifyDetailsJson={item.modifyDetailsJson!}
        />
      );
    //modifica dati pagamento
    case "SUBPMMC":
      return (
        <SubjectCreatedPaymentMethodDescription
          modifyDetailsJson={item.modifyDetailsJson!}
        />
      );
    case "SUBPMMU":
      return (
        <SubjectUpdatedPaymentMethodDescription
          modifyDetailsJson={item.modifyDetailsJson!}
        />
      );
    case "SUBPMMD":
      return <SubjectDeletedPaymentMethodDescription 
      modifyDetailsJson={item.modifyDetailsJson!}
      />;
    //modifica dati documenti
    case "SUBDCM":
      return <></>;
    default:
      return null;
  }
};
export default ModifyDescription;
